import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        refreshInterval: Number,
        url: String,
        ready: Boolean,
    }

    connect() {
        this.element.src = this.urlValue

        if (!this.readyValue && this.hasRefreshIntervalValue) {
            this.startRefreshing();
        }
    }

    disconnect() {
        this.stopRefreshing()
    }

    load() {
        this.element.reload()
    }

    startRefreshing() {
        this.refreshTimer = setInterval(() => {
            this.load()
        }, this.refreshIntervalValue)
    }

    stopRefreshing() {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
        }
    }


}
